import { Committente } from 'api'

import { createSyncable, RowBase } from '@/lib/sync-manager/helpers'
import {
  comparePullCheckpoints,
  initialPullCheckpoint,
  pullFromServer,
  type PullCheckpoint,
} from '@/lib/sync-manager/pull-checkpoint'
import type { DexieDatabase } from '@/db/local/dexie-db'

// Define a type that combines the Committente with RowBase requirements
type CommittenteRow = Committente & RowBase

export const createCommittentiSyncable = (db: DexieDatabase) =>
  createSyncable<CommittenteRow, PullCheckpoint | Date>({
    db,
    name: 'committenti',
    pull: {
      batchSize: 200,
      initialCheckpoint: initialPullCheckpoint,
      compareCheckpoints: comparePullCheckpoints,
      handler: pullFromServer<CommittenteRow>('committenti'),
    },
  })
